import { render } from "./EditEtagere.vue?vue&type=template&id=9634f83a&ts=true"
import script from "./EditEtagere.vue?vue&type=script&lang=ts"
export * from "./EditEtagere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__